/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%}[_nghost-%COMP%]   .mat-form-field-disabled[_ngcontent-%COMP%]     app-ng-datepicker{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default;pointer-events:none}"];
export { styles as styles };
